import { render, staticRenderFns } from "./DomainDetail.vue?vue&type=template&id=3931a97c&scoped=true&"
import script from "./DomainDetail.vue?vue&type=script&lang=js&"
export * from "./DomainDetail.vue?vue&type=script&lang=js&"
import style0 from "./DomainDetail.vue?vue&type=style&index=0&id=3931a97c&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3931a97c",
  null
  
)

export default component.exports